import { animate, state, style, transition, trigger } from '@angular/animations';



export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate('0.4s ease-in', style({ opacity: 1 }))]),
  transition(':leave', [animate('0.4s 10ms ease-out', style({ opacity: 0 }))])
])

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [style({ opacity: 0 }), animate('0.4s ease-in', style({ opacity: 1 }))]),
])


export function fadeInSlideFromDown(pixelsX: number = 30) {
  return trigger('fadeInSlideFromDown', [
    transition(':enter', [
      style({ opacity: 0, transform: `translateY(${pixelsX}px` }),
      animate('0.2s ease-in', style({ opacity: 1, transform: 'translateX(0px)' }))
    ]),
  ])
}

export function flyInOut(duration: number = 0.2) {
  return trigger('flyInOut', [
    state('in', style({ opacity: 1, transform: 'translateX(0)' })),
    transition('void => *', [style({ opacity: 0, transform: 'translateX(-100%)' }), animate(`${duration}s ease-in`)]),
    transition('* => void', [animate(`${duration}s 10ms ease-out`, style({ opacity: 0, transform: 'translateX(100%)' }))])
  ])
}

export function slideFromLeftInOut(pixelsX: number = 30) {
  return trigger('slideFromLeftInOut', [
    transition(':enter', [
      style({ opacity: 0, transform: `translateX(-${pixelsX}px)` }),
      animate('200ms ease-in', style({ opacity: 1, transform: 'translateX(0px)' }))
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0, transform: `translateX(-${pixelsX}px)` }))
    ])
  ])
}

export function slideFromTopInOut(pixelsY: number = 30) {
  return trigger('slideFromTopInOut', [
    transition(':enter', [
      style({ opacity: 0, transform: `translateY(-${pixelsY}px)` }),
      animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(0px)' }))
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0, transform: `translateY(-${pixelsY}px)` }))
    ])
  ])
}

export const animateText = trigger('animateText', [
  state('hide',
    style({
      'display': 'none',
      opacity: 0,
    })
  ),
  state('show',
    style({
      'display': 'block',
      opacity: 1,
    })
  ),
  transition('close => open', animate('350ms ease-in')),
  transition('open => close', animate('200ms ease-out')),
]);

export const onMainContentChange = trigger('onMainContentChange', [
  state('close',
    style({
      'margin-left': '96px'
    })
  ),
  state('open',
    style({
      'margin-left': '266px'
    })
  ),
  transition('close => open', animate('250ms ease-in')),
  transition('open => close', animate('250ms ease-in')),
]);

export const onSideNavChange = trigger('onSideNavChange', [
  state('close',
    style({
      'min-width': '40px',
      'width': '40px',
      'background-color': 'rgba(153, 153, 153, 0.1)',
    })
  ),
  state('open',
    style({
      'min-width': '200px'
    })
  ),
  //transition('close => open', animate('250ms ease-in')),
  transition('open => close', animate('250ms ease-in')),
]);
